<template>
    <el-drawer
        title="添加分词"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-form               
                :model="formData"
                :rules="rules"
                label-position="top"
                ref="formData"
            >
                <el-form-item prop="word" label="分词:">                   
                    <el-input
                        v-model="formData.word"
                        placeholder="请输入分词"                                             
                        size="medium"
						maxlength="20"
                    ></el-input>
				</el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >添加</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
const defaultFormData = {
    word: ""
}
export default {
    data() {
        return {
            drawerShow: false,
            btnLoading:false,
            formData: {
                ...defaultFormData
            },
            rules: {
                word: [{ required: true, message: "请输入分词" }],
            },
            
        };
    },
    methods: {
        close() {
            this.formData = {...defaultFormData};            
            this.$refs.formData.resetFields();
            this.drawerShow = false;
        },
        show() {         
            
            this.drawerShow = true;
        },
        //表单提交
        submitForm() {
            let self = this;
            self.$refs["formData"].validate((valid) => {
                if (valid) {
                   
                    this.btnLoading = true;
                    this.$request({
                        url: "/hotWords/add",
                        params: this.formData,
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit('update');
                                self.close();
                            } else {
                                self.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.number{
    width: 200px;
}
</style>